import { useMutation } from "@tanstack/react-query";
import { createShipApi } from "@/API/createShipApi";
import { ShipCreatePayload, ShipDataType } from "@/types/apiTypes";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";
import { useErrorBoundary } from "@/hooks/helperHooks/useErrorBoundary";

export const useCreateShip = () => {
  const { invalidateShips } = useInvalidateQueries();
  const handleError = useErrorBoundary();
  return useMutation<ShipDataType, Error, ShipCreatePayload>({
    mutationFn: (shipData) => createShipApi(shipData),
    onSuccess: (_data, variables) => {
      invalidateShips();
      ShowNotification({
        title: "Ship Created",
        message: `${variables.ship_name} has been created successfully.`,
        color: "success",
      });
    },
    onError: (error: Error) => {
      ShowNotification({
        title: "Error",
        message: "Failed to create the ship.",
        color: "error",
      });
      handleError(error);
    },
  });
};
